import React from "react";
import { getObject, translate } from "../../utils/useful";
import FormViewer from "../FormViewer";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class FormViewerInput extends React.Component {
    state = {

        headers: [
            // { key: 'label', type: 'TextInput', col: '12', information: { label: '{{lang}}label', placeholder: '{{lang}}text', required: false } },
            // { key: 'function', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'View Record', value: 'openEditModal' }, { title: 'Open window', value: 'openWindow' }, { title: 'Download File', value: 'downloadFile' }, { title: 'Trigger an automation', value: 'manualTrigger' }], label: 'Function', placeholder: 'Choose...', required: true } },
        ],
        fieldsData: [],

        checked: true
    }

    componentWillMount() {
        this.makeFields()
    }

    componentDidUpdate(prevProps) {

        let fullData = this.props.fullData
        let header = this.props.header

        if (header.fieldsKey) {

            let data = getObject(fullData, header.fieldsKey)

            if (data != this.state.fieldsData) {

              
                this.setState({ fieldsData: data }, () => {

                    this.makeFields()
                })
            }

        }

        // if (prevProps.data != this.props.data) {
        //     this.makeFields()
        // }
    }

    makeFields = () => {

        let fullData = this.props.fullData
        let header = this.props.header
        if (header.fieldsKey) {


            let data = getObject(fullData, header.fieldsKey)

            // console.log("init 0", JSON.stringify(this.state.fieldsData ?? ''))
            // console.log("init 1", JSON.stringify(data ?? ''))


            if (Array.isArray(data)) {

                console.log("OK")

                let headers = []

                if (data[0]?.pageId) {

                    data.forEach(page => {
                        page.pageContent.forEach(section => {
                            section.sectionContent.forEach(row => {
                                row.rowContent.forEach(input => {

                                    headers.push(input)

                                });
                            });
                        });
                    })

                } else {
                    headers = data
                }

                this.setState({ headers })

            }

        }
    }



    checkSettings(param) {

        if (this.props.settings) {
            return this.props.settings[param]
        } else {
            return false
        }
    }

    liveChange = (data, init, key, value, extra, full) => {

        if (!init) {
            this.props.changeValue(this.props.header.key, data, this.props.extra)
        }

    }


    render() {
        let info = this.props.header?.information
        return (
            <div className='w-100 px-2 pt-2 pb-1'>

                <FormViewer ref={(el) => this.formViewer = el} headers={this.state.headers} initData={this.props.data} liveChange={this.liveChange} noBtn={true} width={this.props.width} onSave={this.onSave} lastStage={this.props.lastStage} saveTitle={translate('ca.Next Step')} formClass={'bordered-form'} inputClass={'bordered-input'} language={this.props.language} isInput={true} variables={this.props.variables} params={this.props.params} nopadding={true} />

            </div>
        );
    }
}

export default FormViewerInput;
